import { render, staticRenderFns } from "./BatchAssignChannelDialog.vue?vue&type=template&id=d827fe94"
import script from "./BatchAssignChannelDialog.js?vue&type=script&lang=js&external"
export * from "./BatchAssignChannelDialog.js?vue&type=script&lang=js&external"
import style0 from "./BatchAssignChannelDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports